var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 3,
    height: 30,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 2,
    width: 3,
    height: 30,
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(90 20 14)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 5,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(90 29 5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(90 14 29)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 20,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(90 35 20)"
  })));
}
export default SvgBars;